import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PasswordComponent } from './password.component';

@NgModule({
	imports: [
		RouterModule.forChild([
			{
				path:'',
				component: PasswordComponent
			}
		])
	],
	exports: [
		RouterModule
	]
})
export class PasswordRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/view/password/password-routing.module.ts